/* tslint:disable */
import { Injectable } from "@angular/core";

/**
 * Global configuration for ProductApi services
 */
@Injectable({
  providedIn: "root",
})
export class ProductApiConfiguration {
  rootUrl: string = "https://productapi.acc.ejgallo.com";
  constructor() {
    if (location.origin.includes("prd")) {
      this.rootUrl = "https://productapi.prd.ejgallo.com";
    } else if (location.origin.includes("acc")) {
      this.rootUrl = "https://productapi.acc.ejgallo.com";
    } else if (location.origin.includes("dev")) {
      this.rootUrl = "https://productapi.dev.ejgallo.com";
    } else if (location.origin.includes("products.ejgallo.com")) {
      this.rootUrl = "https://productapi.prd.ejgallo.com";
      // MK added to allow DNS move of products.ejgallo.com
    }
  }
}

export interface ProductApiConfigurationInterface {
  rootUrl?: string;
}
